import {
  Component,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Optional,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {BASE_URL} from '@aztrix/environment';
import {downloadDataUrl, generateQR$} from '@aztrix/helpers';
import {TranslateService} from '@aztrix/translate';
import {BehaviorSubject, first, map, Subscription, tap} from 'rxjs';

@Component({
  selector: 'ax-qr-code',
  templateUrl: './qr-code.component.html',
  styleUrls: ['./qr-code.component.scss'],
})
export class QrCodeComponent implements OnInit, OnChanges, OnDestroy {
  @Input() name?: string;
  @Input() avatarUrl?: string;
  @Input() url: string;
  @Input() useAvatar = false;
  @Input() whiteLabel = false;

  generated$ = new BehaviorSubject(false);
  error$ = new BehaviorSubject(false);

  @ViewChild('qrImage', {static: true}) qrImage: ElementRef;

  private _subscriptions = new Subscription();

  constructor(
    @Optional() @Inject(BASE_URL) private _baseUrl: string,
    private _snackbar: MatSnackBar,
    private _translate: TranslateService
  ) {}

  ngOnInit() {
    this._fetchQR().subscribe();

    this._subscriptions.add(
      this.error$.subscribe((error) => {
        if (error) {
          this._snackbar.open(this._translate.instant('error.unknown'), undefined, {
            duration: 2000,
          });
        }
      })
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.useAvatar) {
      this._fetchQR().subscribe();
    }
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  download() {
    this._fetchQR(true).subscribe();
  }

  private _fetchQR(download = false) {
    this.generated$.next(false);
    this.error$.next(false);

    return generateQR$(
      download ? 2500 : 256,
      this.url,
      this.useAvatar
        ? this.avatarUrl
        : this.whiteLabel
          ? undefined
          : `${this._baseUrl}/assets/icons/custom/aztrixlogo_green-border.svg`,
      this.useAvatar
    ).pipe(
      first(),
      map((dataUrl) => {
        if (download) {
          downloadDataUrl(dataUrl, `${this.name}-qr.png`);
        } else {
          this.qrImage.nativeElement.src = dataUrl;
        }
      }),
      tap({
        next: () => {
          this.generated$.next(true);
        },
        error: () => {
          this.error$.next(true);
          this.generated$.next(true);
        },
      })
    );
  }
}
